import { useEffect, useState,useRef  } from 'react'
import Tabs from '../../../../Components/Tabs'
import GetIcon from '../../../../utils/Icon'
import { useNavigate } from 'react-router-dom'
import Tab1 from './Tab1'
import Table from './Table'
import { usePostItemListMutation } from '../../../../store/api/picklist'
import Button from '../../../../Core/Button/Button'
import printerimg from "../../../../assets/print.png"
import { usePostMappedPicklistMutation, usePostCreatePicklistMutation, useGetPicklistDetailsQuery, useLazyGetPicklistDetailsQuery,usePostUpdatePickListMutation,usePostSubmitPickListMutation} from '../../../../store/api/picklist'
import {useCreateDeliveryNotePicklistMutation} from '../../../../store/api/deliveryNoteApi'
import ApiResponseBox from '../../../../Components/ApiResponseBox'
import {usePostSalesOrderListMutation} from '../../../../store/api/salesorderapi'

function Pick() {
   const pageSize = 12;
    const [buttonData, setButtonData] = useState(false)
    const nvg = useNavigate()
    const scanItemRef = useRef(null);
    const [tab, settab] = useState(1)
    const [result, setResult] = useState(false)
    const [tabdata, setTabdata] = useState({})
    const [selected_item_data, setselected_item_data] = useState([]);
    const [getitem_list_data] = usePostItemListMutation()
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [showError, setShowError] = useState(false);
    const [itemList, setItemList] = useState([]);
    console.log(itemList, "itemList");
    const [fulldata, setfulldata] = useState();
    const [item_Rows, setitem_Rows] = useState([]);
    const [postMappedPicklist] = usePostMappedPicklistMutation();
    const [scannedBin, setScannedBin] = useState('');
    const [scannedItem, setScannedItem] = useState('');
    const [scanboll, setscanboll] = useState(false);
    const [picklist_id, setpicklist_id] = useState();
    const [submit, setsubmit] = useState(false);
    const [update, setupdate] = useState(false);
    const [order_id, setorder_id] = useState();
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    // const order_id  = ''
    console.log(order_id, "order_id");
const [activityboll,setactivityboll] =  useState(false)
const [selectRow, setselectRow] = useState("");
const [checkbool,setcheckbool] =  useState(false)
    const [salesData, setsalesData] = useState({ sales_lists: [], total_no_of_records: 0 });

    const [purchaseDataApi] = usePostSalesOrderListMutation();

useEffect(() => {
    const getData = async () => {
        setLoading(true);
        try {
            const response = await purchaseDataApi({
                start:0,
                page_length: 50,
                search_input:order_id
            });

            const filteredSales = response.data.result.sales_orders.filter(
                (order) =>
                    order.status === "Partially Picked" || order.status === "Pick List Created"
            );


            console.log(filteredSales, "Filtered Partially Picked");

            setsalesData({
                ...response.data.result,
                sales_orders: filteredSales
            });
        } catch (error) {
            console.error("Error fetching purchase orders:", error);
        } finally {
            // setLoading(false);
        }
    };
    getData();
}, [currentPage, purchaseDataApi,order_id]);


    const [originalItems, setOriginalItems] = useState([]);

 useEffect(() => {
        if (order_id) {
            postMappedPicklist(order_id)
                .unwrap()
                .then((res) => {
                    console.log("Mapped Picklist Created:", res);
                    setfulldata(res);
                    let updatedRows = res.message.locations.map(item => ({
                        ...item,
                        // to_be_picked: 0,
                        picked_qty: 0,
                    }));
                    setscanboll(true);
                    setItemList(updatedRows);
                    setOriginalItems(updatedRows);
                    setitem_Rows(updatedRows);
                })
            console.log("items not found");
            
        }
    }, [order_id, postMappedPicklist]);





  const [trigger, { data, error2, isFetching2 }] = useLazyGetPicklistDetailsQuery();

const pickListdetail = async (pick_id) => {
    const result = await trigger({ doctype: 'Pick List', name: pick_id }).unwrap();
    setfulldata(result);

    const existingPickedQtys = {};
    item_Rows.forEach(item => {
        existingPickedQtys[item.item_code] = item.picked_qty;
    });

    let updatedRows = result.message.locations.map(item => ({
        ...item,
        picked_qty: existingPickedQtys[item.item_code] || 0,
    }));

    console.log(updatedRows, "updatedRows_after_detailcall");

    setItemList(updatedRows);
    setOriginalItems(updatedRows);
    setitem_Rows(updatedRows);

    return updatedRows; 
};


    const handleBinScan = (e) => {
         scanItemRef.current?.focus();
        e.preventDefault();
        if (scannedBin.trim()) {
            const filtered = originalItems.filter(item => item.warehouse === scannedBin.trim());
            setitem_Rows(filtered);
        } else {
            handleClearBinFilter();
        }
    };
    const handleClearBinFilter = () => {
        setScannedBin('');
        setitem_Rows(originalItems);
    };

const handleItemScan = (e) => {
    e.preventDefault();
    setScannedItem("");

    if (scannedItem.trim()) {
        let flag = false;
        let matchedItem = null;

        try {
            const filtered = item_Rows.map((item) => {
                if (!(item.warehouse == scannedBin.trim())) {
                    throw "Item needs to be in the same Warehouse";
                }

                if (item.item_code === scannedItem.trim()) {
                    const currentPickedQty = parseInt(item.picked_qty || 0);
                    const totalQty = parseInt(item.qty || 0);

                    if (currentPickedQty >= totalQty) {
                        throw "Picked quantity exceeds available quantity";
                    }

                    item.picked_qty = currentPickedQty + 1;
                    flag = true;
                    matchedItem = { ...item }; 
                }

                return item;
            });

            if (flag && matchedItem) {
                const updatedList = [
                    matchedItem,
                    ...filtered.filter((item) => item.item_code !== matchedItem.item_code),
                ];

                setitem_Rows(updatedList);
                setselectRow(matchedItem);
            } else {
                alert("Product Not Found");
            }
        } catch (err) {
            alert(err);
            console.log(err);
        }
    }
};
    const totalPickedQty = item_Rows.reduce((total, item) => {
        return total + (Number(item.picked_qty) || 0);
    }, 0);
  

    const totalQty = item_Rows.reduce((total, item) => {
        return total + (item.order_qty || 0);
    }, 0);
        const totalaccepted = item_Rows.reduce((total, item) => {
        return total + (item.qty || 0);
    }, 0);

    const [postCreatePicklist, { isLoading, isSuccess, isError }] = usePostCreatePicklistMutation();

const handleClick = async () => {
    if (result) return;

    if (!item_Rows?.length) {
        console.warn('No items to save.');
        return;
    }

    const payload = {
        order_id: item_Rows[0]?.sales_order || '',
        items: item_Rows.map(item => ({
            item_code: item.item_code,
            qty: item.qty,
        })),
    };

    try {
        const res = await postCreatePicklist(payload).unwrap();
        console.log('Picklist created:', res);
        setpicklist_id(res.result.pick_list);
        // setscanboll(true);
        // setError('To be Picked Items Created , Please scan item');
        // setptype('Created');
        // setShowError(true);
        
        // Wait for pickListdetail to complete
        const updatedRows = await pickListdetail(res.result.pick_list);
        
        handleClicksave(res.result.pick_list,updatedRows);
    } catch (err) {
        console.error('Error creating picklist:', err);
    }
};


    const [postupdatePicklist, { isLoadingtwo, isSuccesstwo, isErrortwo }] = usePostUpdatePickListMutation();

    
    const handleClicksave = (pick_id,updatedRows) => {
        if (result) return;

         const rowsToUse = updatedRows?.length ? updatedRows : item_Rows;

        if (!rowsToUse?.length) {
            console.warn('No items to save.');
            return;
        }


        const payload = {
            name: pick_id || picklist_id,
            locations: rowsToUse.map(item => ({
                name: item.name,
                item_code: item.item_code,
                warehouse:item.warehouse,
                picked_qty:item.picked_qty,
                qty: item.qty,
            })),
        };
        console.log(payload, "payload");


        postupdatePicklist(payload)
            .unwrap()
            .then(res => {
                console.log('Picklist updated:', res);
                setupdate(true)
                setError('Updated');
                setptype('Picklist Created');
                setShowError(true);
                setactivityboll(prev => !prev);
                setcheckbool(true)
                // setpicklist_id(res.result.pick_list)
                // setscanboll(true)
                // pickListdetail(res.result.pick_list)
            })
            .catch(err => {
                alert('Error creating picklist:', err)
                console.error('Error creating picklist:', err);
            });
    };


    
        const [postsubmitPicklist, { isLoadithree, isSuccessthree, isErrorthree }] = usePostSubmitPickListMutation();


    const handleClicksubmit = () => {
        if (result) return;

        if (!item_Rows?.length) {
            console.warn('No items to save.');
            return;
        }

        const payload = {
            name: picklist_id,
           
        };
        console.log(payload, "payload");


        postsubmitPicklist(payload)
            .unwrap()
            .then(res => {
                console.log('Picklist submited:', res);
                setsubmit(true)
                setError('Submited');
                setptype('Picklist submited');
                setShowError(true);
                setactivityboll(prev => !prev);
                
            })
            .catch(err => {
                console.error('Error creating picklist:', err);
            });
    };


    const [createDeliveryNote, { isLoadingfive, errortwo }] = useCreateDeliveryNotePicklistMutation();

    const handleDevlivaryPick = async () => {
        try {
            const response = await createDeliveryNote(picklist_id).unwrap();

            const delivery_note_id = response.result.delivery_note_id
            console.log('Delivery Note created:', delivery_note_id);
            nvg('/outbound/outbound-create-delivery-note', {
                state: {delivery_note_id:delivery_note_id }
            });
        } catch (error) {
            console.error('Failed to create pick:', error);
            alert('Error creating pick. Please try again.');
        }
    };


    return (
        <>
            <Tabs />
            <div className="d-flex justify-content-between p-2 " style={{ background: "#fcfdfe",height:'40px' }}>
                <div className="d-flex align-items-center customizewidth">
                    <p className="m-0 breadcrumb-item">Outbound</p>
                    <p className="m-0 "> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={17} /> </p>
                    <p className="m-0 breadcrumb-item">Pick List </p>
                    <p className="m-0 ">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={17} />  </p>
                    <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79" }} >
                        New Pick
                        <button
                            className={` ${submit
                                ? 'rounded-pill newdesign123'
                                : 'rounded-pill newdesign2343'
                                }`}
                        >
                            {submit ? 'Submitted' : scanboll ? 'Draft' : 'New'}
                        </button>
                    </a>
                </div>
                <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }} >
                {submit &&  <Button
                        style={{ gap: '2px' }}
                        className="custom-btn-00989"
                        iconName="LuFilePlus2"
                        iconSize={12}
                        onClick={handleDevlivaryPick}
                        disabled={isLoading}
                    >
                    Create Delivary note                   
                </Button>}
               
                    <Button
                        style={{ gap: '2px' }}
                        className="custom-btn-bluecolor"
                        iconName="BiCloudUpload"
                        iconSize={14}
                    >
                        Upload
                    </Button>

                    <Button
                        style={{ gap: '2px' }}
                        className="createbtn"
                        iconName="GrCopy"
                        iconSize={12}
                    >
                        Duplicate
                    </Button>
{!submit && (

                    <Button
                        style={{ gap: '2px' }}
                        className="custom-btn-00989"
                        iconName="LuFilePlus2"
                        iconSize={12}
                        onClick={()=>{
                            checkbool?handleClicksave():handleClick()
                        }}
                        disabled={isLoading}
                    >
                        {checkbool ? 'Update' : 'Save'}
                    </Button>
                    )}
                    {update && !submit && (
                            <Button
                                style={{ gap: '2px' }}
                                className="custom-btn-00989"
                                iconName="LuFilePlus2"
                                iconSize={12}
                                onClick={handleClicksubmit}
                                disabled={isLoading}
                            >
                                Submit
                            </Button>
                            )}

              
                    <Button
                        to="/some-path"
                        className="px-2"
                        imgSrc={printerimg}
                        imgStyle={{ width: '21px' }}
                    />
                </div>
            </div>
            <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul
                            className="nav nav-tabs mb-0"
                            style={{ color: "white", border: "none" }}
                        >
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                <a
                                    className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"}
                                    onClick={() => { settab(1) }}
                                    href="javascript:void(0);"
                                >
                                    General Details
                                    {tab == 1
                                        ? <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                                        : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>
                        </ul>
                        <div className="d-flex align-items-center mb-2 px-3" style={{ gap: "2px", fontSize: '12px' }}>
                            <span style={{ position: 'relative', top: '-1px' }}>
                                <GetIcon iconName="CgAttachment" size={12} />
                            </span>
                            <span className=" fw-semibold" style={{ color: "#391F84" }}>
                                Attachments
                            </span>
                        </div>
                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px' }}>
                    <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <Tab1 fulldata={fulldata} order_id={order_id} setorder_id={setorder_id} salesData={salesData} activityboll={activityboll} picklist_id={picklist_id} />
                    </div>
                    <div className="col-9" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
                        <div className="d-flex justify-content-between align-items-center pb-2" style={{ gap: '5px' }}>
                            {/* Left Side Text Info */}
                            <div className="d-flex" style={{ gap: '10px' }}>
                                <p className="NoOfLine">
                                    No. of lines - <span style={{ color: '#2563EB' }}>{item_Rows.length}</span>
                                </p>
                                <p className="TotalQty">
                                    Total Quantity - <span style={{ color: '#16A34A' }}>{totalaccepted > 0 ? totalaccepted : totalQty}</span>
                                </p>
                                <p className="ReceivedQty">
                                    Scanned Quantity - <span style={{ color: '#EC642A' }}>{totalPickedQty}</span>
                                </p>
                            </div>
                            {scanboll &&
                                <div className="d-flex mx-2" style={{ gap: '10px', borderColor: 'rgba(0,0,0,0.2)' }}>
                                    <form onSubmit={handleBinScan}>
                                        <div className="position-relative">
                                            <input
                                                type="text"
                                                name="binScan"
                                                placeholder="Scan Bin"
                                                className="form-control pe-4"
                                                value={scannedBin}
                                                onChange={(e) => setScannedBin(e.target.value)}
                                                style={{
                                                    width: '227px',
                                                    border: '1px solid #333',
                                                }}
                                            />
                                            <button
                                                type="submit"
                                                className="position-absolute"
                                                style={{
                                                    top: '50%',
                                                    right: '10px',
                                                    transform: 'translateY(-50%)',
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: 'pointer',
                                                    color: "#EC642A"
                                                }}
                                            >
                                                <GetIcon iconName="BsUpcScan" design="cursor-pointer" size={15} />
                                            </button>
                                        </div>
                                    </form>



                                    <form onSubmit={handleItemScan}>
                                   <div className="position-relative" style={{ width: '227px' }}>
                                        <div
                                            style={{ position: 'relative' }}
                                            title={!scannedBin ? 'Scan Bin' : ''} 
                                        >
                                            <input
                                            ref={scanItemRef}
                                            type="text"
                                            placeholder="Scan Item"
                                            className="form-control pe-4"
                                            value={scannedItem}
                                            onChange={(e) => setScannedItem(e.target.value)}
                                            disabled={!scannedBin}
                                            style={{
                                                width: '100%',
                                                border: '1px solid #333',
                                                backgroundColor: !scannedBin ? '#f1f1f1' : 'white',
                                                cursor: !scannedBin ? 'not-allowed' : 'text',
                                            }}
                                            />

                                            {!scannedBin && (
                                            <div
                                                style={{
                                                position: 'absolute',
                                                top: '50%',
                                                right: '40px',
                                                transform: 'translateY(-50%)',
                                                pointerEvents: 'none',
                                                color: '#999',
                                                }}
                                            >
                                                <GetIcon iconName="MdBlock" size={16} /> 
                                            </div>
                                            )}
                                        </div>

                                        <button
                                            type="submit"
                                            className="position-absolute"
                                            disabled={!scannedBin}
                                            style={{
                                            top: '50%',
                                            right: '10px',
                                            transform: 'translateY(-50%)',
                                            background: 'none',
                                            border: 'none',
                                            padding: 0,
                                            cursor: !scannedBin ? 'not-allowed' : 'pointer',
                                            color: "#EC642A",
                                            }}
                                            title={!scannedBin ? 'Scan Bin' : 'Submit'} 
                                        >
                                            <GetIcon iconName="BsUpcScan" design="cursor-pointer" size={15} />
                                        </button>
                                        </div>

                                    </form>
                                </div>}

                        </div>

                        <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
                            <p style={{ color: "#1E1E1E", fontWeight: '500' }}>
                                Item Details
                            </p>
                        </div>
                        <Table list_data={itemList} fulldata={fulldata} row={{ Rows: item_Rows, setRows: setitem_Rows,selectRow }} scanboll={scanboll} submit={submit}/>
                    </div>
                </div>

                 <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />            
      </div>
        </>
    )
}

export default Pick